module.exports = __webpack_public_path__ + "img/link-orange.23c9933c.svg";